import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        
        // Get country from timezone (simple approximation)
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let country = 'Unknown';
        
        // Get country from IP geolocation API
        try {
          const geoResponse = await fetch('https://ipapi.co/json/');
          if (geoResponse.ok) {
            const geoData = await geoResponse.json();
            country = geoData.country_name || timezone;
          }
        } catch {
          country = timezone;
        }
        
        await supabase.from('page_visits').insert({
          page_path: location.pathname,
          user_id: user?.id || null,
          user_agent: navigator.userAgent,
          referrer: document.referrer || null,
          country: country,
        });
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Page tracking error:', error);
      }
    };

    trackPageView();
  }, [location.pathname]);
}
